module.exports = __webpack_public_path__ + "static/img/chuzhongwuli2.e911f95c.jpg";